import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type NoCloudShellFullAccessConfig = typeof NoCloudShellFullAccessConfig._.Config;

export const NoCloudShellFullAccessConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.NoCloudShellFullAccess,
  configSchema: z.object({}),
});
